<script setup lang="ts">
	const props = defineProps<{
		cardClass?: ClassContext
		validate?: () => Promise<boolean | null>
	}>()
	type AccountDetailSteps = {
		title: string
		key: string
		active: boolean
		complete: boolean
	}
	const businessSteps = ref<Array<AccountDetailSteps>>([
		{
			active: true,
			complete: false,
			key: 'aboutBusiness',
			title: 'Tell us about your business'
		},

		{
			active: false,
			complete: false,
			key: 'introduction',
			title: 'Contact Person'
		}
	])

	const startIndex = ref(0)

	const toggle = (e: AccountDetailSteps) => {
		if (e.complete) {
			e.active = !e.active
		}
	}

	const next = async (arg: string) => {
		const businessStepsLength = businessSteps.value.length

		const selectedBusinessStep = businessSteps.value.find(items => items.key === arg) as AccountDetailSteps

		if (props.validate) {
			const response = await props.validate()
			if (!response) {
				return
			}
		}
		if (!selectedBusinessStep?.complete) {
			selectedBusinessStep.complete = true
			toggle(selectedBusinessStep)
			if (startIndex.value < businessStepsLength - 1) {
				startIndex.value++
				businessSteps.value[startIndex.value].active = true
			}
		} else {
			toggle(selectedBusinessStep)
		}
	}
</script>

<template>
	<div>
		<shared-card
			v-for="(item, index) in businessSteps"
			:key="index"
			:default-class="cardClass"
			:ui="{
				container: 'shadow-none sm:px-[32px] sm:py-[28px] rounded-sm'
			}"
		>
			<div class="flex items-center justify-between" @click="toggle(item)">
				<div class="flex items-center gap-3 text-lg font-medium tracking-wide text-gray-700">
					<span>{{ index + 1 }}.</span>
					<span>{{ item.title }}</span>
				</div>

				<lazy-tools-icon v-show="item.complete" icon="check" dir="fill" :height="24" :width="24" />
			</div>

			<slot :name="item.key" :data="item" :next="next" />
		</shared-card>
	</div>
</template>
